import React, { useEffect, useState } from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';
import 'ag-grid-enterprise';
import 'ag-grid-enterprise/styles/ag-grid.css'; // Core grid CSS, always needed
import 'ag-grid-enterprise/styles/ag-theme-balham.css';
import redirectURL from "../redirectURL";
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import 'react-datetime/css/react-datetime.css';
import Datetime from 'react-datetime';
import moment from "moment";
import Select from 'react-select';


var decipher = salt => {
    const textToChars = text => text.split('').map(c => c.charCodeAt(0));
    const applySaltToChar = code => textToChars(salt).reduce((a, b) => a ^ b, code);
    return encoded => encoded.match(/.{1,2}/g)
        .map(hex => parseInt(hex, 16))
        .map(applySaltToChar)
        .map(charCode => String.fromCharCode(charCode))
        .join('');
}
var decode = decipher("Z744cRBHYjQTsI6cOlNaUKbuEQF6MiEr");
var localStorageRole = (localStorage.getItem("role"));

const SLAAdherenceDashboard = () => {
    var [rowData, setrowData] = useState([]);
    var [overly, setoverly] = useState('show-n');
    var [loadshow, setloadshow] = useState('show-n');
    var [show, setshow] = useState(false);
    var [basicTitle, setbasicTitle] = useState('');
    var [basicType, setbasicType] = useState('');
    var [from_date, setfrom_date] = useState(moment().format('DD-MM-YYYY'));
    var [end_date, setend_date] = useState(moment().add(2, 'days').format('DD-MM-YYYY'));
    var [avgIntransit, setAvgIntrnasit] = useState([]);
    var [avgHalt, setAvgHalt] = useState([]);
    var [categories, setCategories] = useState([]);
    var [consignerCode, setConsignerCode] = useState({label:'All', value:'all'})
    var [consigneeCode, setConsigneeCode] = useState({label:'All', value:'all'})
    var [selectedType, setSelectedType] = useState('FTL'); // State to toggle between FTL and PTL
    // var [consignerList, setConsignerList] = useState([])
    // var [consigneeList, setConsigneeList] = useState([])
    var [consigneesList, setConsigneesList] = useState([])
    var [consignersList, setConsignersList] = useState([])

    const options = {
        chart: {
            type: 'column',
            height: 190
        },
        title: {
            text: '',
            align: 'left'
        },
        xAxis: {
            categories: categories, // Use dynamically set categories
            crosshair: true,
            title: {
                text: 'Consigner - Consignee'
            }
        },
        yAxis: {
            min: 0,
            title: {
                text: "Consignments avg. transit time and halts"
            },
            labels: {
                formatter: function () {
                    return this.value
                }
            },
        },
        tooltip: {
            valueSuffix: ''
        },
        plotOptions: {
            column: {
                borderWidth: 0,
                dataLabels: {
                    enabled: true,
                    style: {
                        color: 'black',
                        textOutline: 'none'
                    },
                    align: 'center',
                    verticalAlign: 'bottom',
                    y: -10,
                    x: 0
                }
            },
        },
        colors: ["#1cc88a", "#28bad4"],
        series: [
            {
                name: 'Avg. In Transit Time',
                data: avgIntransit, 
            },
            {
                name: 'Avg. Halt',
                data: avgHalt, 
            },
        ],
        credits: {
            enabled: false
        }
    };

    useEffect(() => {
        getData(from_date, end_date, consigneeCode, consignerCode);
    }, [selectedType]); // Call getData whenever the selectedType (FTL/PTL) changes

    useEffect(() => {
        redirectURL.post('/consignments/getConsignersandConsignees')
            .then((resp) => {
                try {
                    // Handle your response here
                    let consignees_data = resp.data.consignees;
                    let consigneesList = consignees_data.map(e=>(
                        {label: e.consignee_code, value:e.consignee_code}
                    ))
                    console.log(consigneesList, "consigneesList123");
                    
                    setConsigneesList(consigneesList)
                    let consigners_data = resp.data.consigners;
                    let consignersList = consigners_data.map(e=>(
                        {label: e.consigner_code, value:e.consigner_code}
                    ))
                    console.log(consignersList, "consignersList123");

                    setConsignersList(consignersList)
                } catch (error) {
                    console.error("Error handling response: ", error);
                }
            })
            .catch((error) => {
                console.error("API request error: ", error);
            });
    }, []); // Add dependencies as needed
    



    const getData = (from_date, to_date, consigneeCode, consignerCode) => {
        setloadshow('show-m');
        console.log(consigneeCode, "consigneeCode");
        
        var params = {
            from_date: formatDate(from_date),
            to_date: formatDate(to_date),
            consignee_code: consigneeCode.value,
            consigner_code: consignerCode.value
        }
        console.log(params, "paramsss")
        
        redirectURL.post('/consignments/getslaadherence', params).then((resp) => {
            try {
                var data = resp.data;
                var location = localStorage.getItem("location");
                if (decode(localStorageRole).toLowerCase() === "user") {
                    // Set filter parameters
                    if(["all numeric shipments", "all sites", "all shipment"].includes(location.toLowerCase())){

                    const consignerFilter = location;
                    const consigneeFilter = location;
                    // Filter records based on consigner_code and consignee_code
                    data = data.filter(record => 
                        record.consigner_code === consignerFilter ||
                        record.consignee_code === consigneeFilter
                    );
                }
                const truckSealEntity = localStorage.getItem("entity");
                if (truckSealEntity  && truckSealEntity !== undefined && truckSealEntity !== null && truckSealEntity.trim() !== "") {
                    
                    // Additional filtering based on truck_seal_entity
                    data = data.filter(record => record.truck_seal_entity === truckSealEntity);
                } 
                }
                          

                console.log(data, "dataslaadherence");

                var ftlData = data.ftl_cons;
                var ptlData = data.ptl_cons;

                // Handle data toggle
                let selectedData = selectedType === 'FTL' ? ftlData : ptlData;

                // Create categories for the xAxis combining consigner_name and consignee_name
                const categories = selectedData.map(e => `${e.consigner_name} - ${e.consignee_name}`);

                var consignerList1 = []
                var consigneeList1 = []

                // if (selectedType === 'FTL'){
                //     consignerList1 = selectedData.map(e=>({
                //         label:e.consigner_name, value:e.consigner_name}))
                //     consigneeList1 = selectedData.map(e=>({
                //             label:e.consignee_name, value:e.consignee_name}))   
                //     setConsignerList(consignerList1)
                //     setConsigneeList(consigneeList1)

                // }
                // setConsignerList(consignerList1)
                // var consignerList2 = []
                // var consigneeList2 = []
                // if (selectedType === 'PTL'){
                //     consignerList2 = selectedData.map(e=>({
                //         label:e.consigner_name, value:e.consigner_name}))
                //     consigneeList2 = selectedData.map(e=>({
                //         label:e.consignee_name, value:e.consignee_name}))
                //         setConsignerList(consignerList2)
                //         setConsigneeList(consigneeList2)    
                // }

                // Map average transit times for FTL or PTL
                const avgTransitTime = selectedData.map(e => e.avg_transit_time || 0);

                // Map average halt times for FTL or PTL (use 0 if PTL does not have halt time)
                const avgHaltTime = selectedData.map(e => e.avg_halt_time || 0);

                setCategories(categories);  // Set the xAxis categories
                setAvgHalt(avgHaltTime);
                setAvgIntrnasit(avgTransitTime);

                console.log(categories, avgTransitTime, avgHaltTime);

            } catch (e) {
                setrowData([]);
                console.error('Error:', e);
            } finally {
                setTimeout(() => {
                    setloadshow('show-n');
                }, 3000);
            }
        }).catch(error => {
            console.error('Fetch error:', error);
            setrowData([]);
            setTimeout(() => {
                setloadshow('show-n');
            }, 3000);
        });
    };

    const filterDatafordates = () => {
        var from_date1 = from_date;
        var to_date1 = end_date;
        
        if (from_date1 && to_date1 && from_date1 <= to_date1 && consignerCode!='' && consigneeCode !='') {
           getData(from_date1, to_date1, consigneeCode, consignerCode);
        } else {
            setbasicTitle('From Date should be less than To Date');
            setbasicType('danger');
            setshow(true);
        }
    };

    const handleDatesSelected = (e) => {
        const date = moment(e).format('DD-MM-YYYY');
        setfrom_date(date);
    };
    const handleDatesSelected1 = (e) => {
        const date = moment(e).format('DD-MM-YYYY');
        setend_date(date);
    };

    const handleToggle = (type) => {
        setSelectedType(type); // Set the selected type (FTL/PTL)
    };
   

    return (
        <>
            <SweetAlert
                show={show}
                type={basicType}
                title={basicTitle}
                onConfirm={() => setshow(false)}
            ></SweetAlert>

<div className='card-header2'>
    <div className='d-flex justify-content-between'>
        <h1 className='heading3 mt-20p ml-5p col-3' style={{ width: "240px" }}>SLA Adherence</h1>
        <div className="row justify-content-end align-items-center w-100 ml-20p">
            {/* Select Consigner */}
            <div className="form-group col-lg-2" style={{marginTop:"-10px"}}> {/* Decreased the column width */}
                <label className='dateStyling'> Select Consigner </label>
                <Select
                    closeMenuOnSelect={false}
                    name="consigner"
                    placeholder="Select Consigner"
                    className="rselect"
                    value={consignerCode}
                    onChange={(e) => setConsignerCode(e)}
                    options={consignersList}
                    styles={{
                        control: (base, state) => ({
                            ...base,
                            minHeight: '20px',   // Reduced the minimum height of the control
                            height: '30px',      // Set the overall height of the control
                            fontSize: '12px',    // Reduce the font size
                            padding: '0px',      // Remove padding to reduce height further
                        }),
                        valueContainer: (base) => ({
                            ...base,
                            padding: '0px 8px',  // Adjust padding inside the value container
                        }),
                        input: (base) => ({
                            ...base,
                            margin: '0px',       // Remove margin around the input field
                            padding: '0px',      // Remove padding inside the input
                        }),
                        indicatorsContainer: (base) => ({
                            ...base,
                            height: '30px',      // Align the dropdown indicators with the new height
                        }),
                        menu: (base) => ({
                            ...base,
                            fontSize: '12px',    // Reduce font size in dropdown options
                        }),
                    }}
                />
            </div>


            <div className="form-group col-lg-2" style={{marginTop:"-10px"}}>
                <label className='dateStyling'> Select Consignee </label>
                <Select
                    closeMenuOnSelect={false}
                    name="consignee"
                    placeholder="Select Consignee"
                    className="rselect"
                    value={consigneeCode}
                    onChange={(selectedOption) => setConsigneeCode(selectedOption)}
                    options={consigneesList}
                    styles={{
                        control: (base, state) => ({
                            ...base,
                            minHeight: '20px',   // Reduced the minimum height of the control
                            height: '30px',      // Set the overall height of the control
                            fontSize: '12px',    // Reduce the font size
                            padding: '0px',      // Remove padding to reduce height further
                        }),
                        valueContainer: (base) => ({
                            ...base,
                            padding: '0px 8px',  // Adjust padding inside the value container
                        }),
                        input: (base) => ({
                            ...base,
                            margin: '0px',       // Remove margin around the input field
                            padding: '0px',      // Remove padding inside the input
                        }),
                        indicatorsContainer: (base) => ({
                            ...base,
                            height: '30px',      // Align the dropdown indicators with the new height
                        }),
                        menu: (base) => ({
                            ...base,
                            fontSize: '12px',    // Reduce font size in dropdown options
                        }),
                    }}
                />
            </div>

            
            {/* From Date */}
            <div className="form-group col-lg-1" style={{marginTop:"-35px", }}>
                <label className='dateStyling' style={{width:"100px"}}> From Date </label>
                <Datetime
                    className='smaller-datetime'
                    key={from_date}
                    placeholder="Date"
                    disableCloseOnClickOutside={false}
                    closeOnSelect={true}
                    value={from_date}
                    dateFormat="DD-MM-YYYY"
                    timeFormat={false}
                    onChange={handleDatesSelected}
                    required
                />
            </div>

            {/* To Date */}
            <div className="form-group col-lg-1 ml-20p" style={{marginTop:"-35px"}}>
                <label className='dateStyling'> To Date </label>
                <Datetime
                    className='smaller-datetime'
                    key={end_date}
                    placeholder="Date"
                    disableCloseOnClickOutside={false}
                    closeOnSelect={true}
                    value={end_date}
                    dateFormat="DD-MM-YYYY"
                    timeFormat={false}
                    onChange={handleDatesSelected1}
                    required
                />
            </div>

            {/* Submit Button */}
            <div className="form-group col-lg-1 ml-20p" style={{marginTop:"-35px"}}>
                <button className="custom-btn1 f10 label label-success mt-30p" onClick={filterDatafordates}>Submit</button>
            </div>
        </div>
    </div>

    {/* Toggle FTL and PTL */}
    <div className="toggle-container text-center">
        <button 
            className={`btn1 ${selectedType === 'FTL' ? 'btn-active' : 'btn-inactive'}`} 
            onClick={() => handleToggle('FTL')}
        >
            FTL
        </button>
        <button 
            className={`btn1 ${selectedType === 'PTL' ? 'btn-active' : 'btn-inactive'}`} 
            onClick={() => handleToggle('PTL')}
        >
            PTL
        </button>
    </div>

    <HighchartsReact highcharts={Highcharts} options={options} />
</div>


            <div className={"dataLoadpage1 " + (loadshow)}></div>
            <div className={"dataLoadpageimg " + (loadshow)}>
                <div className="loader-box"><div className="loader"></div></div>
            </div>
            <div className={"overlay-part " + (overly)} onClick={() => setloadshow('show-n')}></div>
        </>
    )
}

function formatDate(dateString) {
    const parts = dateString.split('-');
    const day = parts[0];
    const month = parts[1];
    const year = parts[2];
    return `${year}-${month}-${day}`;
}

export default SLAAdherenceDashboard;
